import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import {
  APPEARANCE_STORAGE_KEY,
  applyAppearance,
  readStoredAppearance,
} from '../constants/appearance';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [appearance, setAppearanceState] = useState(readStoredAppearance);

  useEffect(() => {
    applyAppearance(appearance);
    try {
      localStorage.setItem(APPEARANCE_STORAGE_KEY, appearance);
    } catch {
      /* ignore quota / private mode */
    }
  }, [appearance]);

  const setAppearance = useCallback((next) => {
    setAppearanceState(next === 'light' ? 'light' : 'dark');
  }, []);

  const value = useMemo(
    () => ({ appearance, setAppearance }),
    [appearance, setAppearance]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
}
